import FilterActionWrapper from './FilterActionWrapper.component';

export default FilterActionWrapper;